module.exports = __webpack_public_path__ + "img/banner.2e06b6c2.jpg";